import React from 'react';
import { Severity } from 'Generated/schema';
import { SEVERITY_COLOR_MAP_V3 } from 'Source/constants';
import { Badge, BadgeProps } from 'pounceV2';

interface SeverityBadgeV3Props extends Omit<BadgeProps, 'children'> {
  severity: Severity;
}

const SeverityBadgeV3 = ({ severity, ...rest }: SeverityBadgeV3Props) => (
  <Badge
    width={70}
    variant={SEVERITY_COLOR_MAP_V3[severity]}
    emphasized
    data-dd-privacy="allow"
    data-testid="badge"
    {...rest}
  >
    {severity}
  </Badge>
);

export default SeverityBadgeV3;
